import { useState, useEffect, useContext, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Editor } from "@tinymce/tinymce-react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { Config } from "../inc/Config";
import Fetch, { UploadFile, Loader } from "../inc/Fetch";
import { Img, PlayAudio } from "./Elements";

import TextInput from "./tiny/textInput";
import ImgInput from "./tiny/imgInput";
import Mp3 from "./tiny/Mp3";
import MathData from "./tiny/Math";

import { AppContext } from "../Context";

import "./css/Form.css";
import {
    IoMdArrowDropdown,
    IoIosCheckbox,
    IoMdRadioButtonOff,
    IoMdRadioButtonOn,
} from "react-icons/io";
import {
    MdOutlineCheckBoxOutlineBlank,
    MdCheckBoxOutlineBlank,
    MdCheckBox,
    MdDelete,
    MdAttachFile,
    MdOutlineArrowDropDown,
} from "react-icons/md";
import {
    IoCheckmarkDoneSharp,
    IoSearch,
    IoClose,
    IoCloudUploadOutline,
    IoImageOutline,
} from "react-icons/io5";
import { GiSoundWaves } from "react-icons/gi";
import VideoInput from "./tiny/VideoInput";

export function Input({
    title,
    name,
    validate,
    type,
    placeholder,
    style,
    error,
    value,
    values,
    onChange,
    inputStyle,
    disabled,
    multiple,
    autoFocus,
    icon,
}) {
    const { t } = useTranslation();
    const [focus, setfocus] = useState(false);
    const [v, setv] = useState(value);
    const [selv, setselv] = useState(false);
    const [open, setopen] = useState("closed");
    const [search, setsearch] = useState("");

    const [access, setaccess] = useState(false);

    if (!type) {
        type = "text";
    }

    useEffect(() => {
        if (type == "select" && values?.length) {
            if (value || value === 0) {
                const selected = values?.filter((p) => p.val == value);
                if (selected?.length) {
                    setselv(selected[0]);
                }
                // setselv(p => p);
            } else {
                setselv(values[0]);
            }
        } else {
            if (value) {
                setv(value);
            }
        }
    }, [value]);

    useEffect(() => {
        const closeFunc = (e) => {
            const selClose = e?.target.closest(".selectBox");
            if (!selClose) {
                setopen("closed");
            }
        };

        window.addEventListener("click", closeFunc);

        return () => {
            window.removeEventListener("click", closeFunc);
        };
    }, []);
    useEffect(() => {
        if (onChange) {
            onChange(v);
        }
    }, [v]);

    return (
        <label
            style={style}
            className={
                "formInputBox " +
                (focus || v || placeholder || type == "select"
                    ? "focused"
                    : "") +
                (error ? " error" : "")
            }
        >
            {title && (
                <span>
                    {`${title}`} {validate && <b>*</b>}
                </span>
            )}
            {type == "select" ? (
                <>
                    <div className="selectBox">
                        <div
                            style={inputStyle}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    setopen((p) => (p ? "open" : "closed"));
                                }
                            }}
                            onClick={() =>
                                disabled
                                    ? false
                                    : setopen((p) => (p ? "open" : "closed"))
                            }
                            tabindex="0"
                            className={`selectName focusedSelect`}
                        >
                            {selv?.name ? selv?.name : values[0]?.name}{" "}
                            <IoMdArrowDropdown />
                        </div>

                        <nav className={"dropDownBox " + open}>
                            <input
                                type="search"
                                onChange={(d) => setsearch(d?.target?.value)}
                                name="q"
                                placeholder={t("search") + ".."}
                            />
                            <div>
                                {values?.map((v, k) => {
                                    let visible = true;
                                    if (search) {
                                        if (
                                            v?.name
                                                ?.toLowerCase()
                                                ?.indexOf(
                                                    search?.toLowerCase(),
                                                ) == -1
                                        ) {
                                            visible = false;
                                        }
                                    }

                                    if (visible) {
                                        return (
                                            <a
                                                href="javascript:void(0)"
                                                className={
                                                    v?.val == value
                                                        ? "selected"
                                                        : "none"
                                                }
                                                onClick={() => {
                                                    setv(v?.val);
                                                    setselv(v);
                                                    setopen("closed");
                                                }}
                                                key={k}
                                            >
                                                {v?.name}
                                            </a>
                                        );
                                    }
                                })}
                            </div>
                        </nav>
                    </div>
                    <input type="hidden" name={name} value={selv?.val} />
                </>
            ) : (
                <>
                    {type == "textarea" ? (
                        <textarea
                            autoFocus={autoFocus}
                            style={inputStyle}
                            disabled={disabled}
                            onFocus={() => setfocus(true)}
                            onBlur={() => setfocus(false)}
                            name={name}
                            onChange={(e) => setv(e?.target?.value)}
                            placeholder={placeholder}
                            defaultValue={v}
                        ></textarea>
                    ) : (
                        <>
                            {icon}
                            <input
                                autoFocus={autoFocus}
                                autoComplete="new-password"
                                type={type}
                                style={inputStyle}
                                disabled={disabled}
                                onFocus={() => setfocus(true)}
                                onBlur={() => setfocus(false)}
                                name={name}
                                onChange={(e) => setv(e?.target?.value)}
                                value={v}
                                placeholder={placeholder}
                            />
                        </>
                    )}
                </>
            )}
            {!v && type != "select" && <hr />}
            {error && <p>{error}</p>}
        </label>
    );
}

export function MultiSelecNew({
    title,
    Icon,
    onChange,
    value,
    values,
    must,
    className,
    disabled,
    style,
}) {
    const { t } = useTranslation();

    const [val, setval] = useState([]);
    const [vals, setvals] = useState([]);
    const [showPass, setshowPass] = useState(false);
    const [focus, setfocus] = useState(true);
    const [dropOpen, setdropOpen] = useState(false);
    const [search, setsearch] = useState("");
    const [addID, setaddID] = useState(
        `p-${Math.floor(Math.random() * 99999999)}`,
    );

    let idKey = false;
    if (values?.length) {
        idKey =
            Object.keys(values[0])[0] == "_id" || idKey == "val"
                ? Object.keys(values[0])[0]
                : Object.keys(values[0])[1];
    }

    function change(data) {
        let ck = val?.filter((r) => r[idKey] == data[idKey]);
        if (ck?.length) {
            setval((p) => {
                let r = p?.filter((f) => f[idKey] != data[idKey]);
                if (!r?.length) {
                    r = [];
                }

                onChange(r);
                return r;
            });
        } else {
            // setval(p => p?.length ? [...p, data] : [data] );
            setval((p) => {
                let arr = [];
                p?.map((v) => {
                    arr.push(v);
                });

                arr.push(data);

                onChange(arr);
                return arr;
            });
        }
    }

    useEffect(() => {
        if (value) {
            setval(value);
        } else {
            // onChange(values);
            setval([]);
        }
    }, [value]);

    useEffect(() => {
        if (values?.length) {
            setvals(values);
        }
    }, [values]);

    useEffect(() => {
        const closeFunc = (e) => {
            const selClose = e?.target.closest(`.${addID}`);
            if (!selClose) {
                setdropOpen(false);
            }
        };

        window.addEventListener("click", closeFunc);

        return () => {
            window.removeEventListener("click", closeFunc);
        };
    }, []);

    let Icon5 = Icon ? Io5[Icon] : <></>;
    return (
        <label
            style={style}
            className={`inputBox ${className || ""} ${focus ? "focused" : ""} ${!Icon ? "noIcon" : ""} ${disabled ? "disabled" : ""} ${addID}`}
        >
            {title && (
                <span>
                    {title} {must && <b>*</b>}
                </span>
            )}

            <div className="formInBox selectType">
                {Icon && <Icon5 />}

                <p
                    onClick={() => setdropOpen((p) => (disabled ? false : !p))}
                    className="selectedInputBox"
                >
                    <b>
                        {val?.length
                            ? val?.map((v, k) => <span key={k}>{v?.name}</span>)
                            : "--"}
                    </b>
                    <MdOutlineArrowDropDown />
                </p>

                {dropOpen && (
                    <ul>
                        <input
                            autoComplete="off"
                            type="search"
                            onChange={(e) => setsearch(e?.target?.value)}
                            placeholder={`${t("search")}..`}
                        />
                        <li>
                            {vals?.map((v, k) => {
                                let show = true;
                                let keys = Object.entries(v);
                                let valsF = keys[0];

                                if (valsF) {
                                    if (
                                        search &&
                                        valsF[1]?.indexOf(search) < 0
                                    ) {
                                        show = false;
                                    }

                                    if (show) {
                                        let ck = val?.filter(
                                            (r) => r[idKey] == v[idKey],
                                        );

                                        if (!v?.parent) {
                                            let subs = vals?.filter(
                                                (r) => r?.parent == v?._id,
                                            );

                                            return (
                                                <nav key={k}>
                                                    <a
                                                        className={`multiCheck ${ck?.length ? "ck2" : "null"}`}
                                                        onClick={() =>
                                                            change(v)
                                                        }
                                                    >
                                                        {ck?.length ? (
                                                            <MdCheckBox />
                                                        ) : (
                                                            <MdOutlineCheckBoxOutlineBlank />
                                                        )}{" "}
                                                        {valsF && valsF[1]}
                                                    </a>

                                                    {subs?.map((v2, k2) => {
                                                        let keys =
                                                            Object.entries(v2);
                                                        let valsF = keys[0];

                                                        let ck = val?.filter(
                                                            (r) =>
                                                                r[idKey] ==
                                                                v2[idKey],
                                                        );

                                                        return (
                                                            <a
                                                                className={`multiCheck ${ck?.length ? "ck2" : "null"}`}
                                                                onClick={() =>
                                                                    change(v2)
                                                                }
                                                                key={k2}
                                                            >
                                                                {" "}
                                                                -{" "}
                                                                {ck?.length ? (
                                                                    <MdCheckBox />
                                                                ) : (
                                                                    <MdOutlineCheckBoxOutlineBlank />
                                                                )}{" "}
                                                                {valsF &&
                                                                    valsF[1]}
                                                            </a>
                                                        );
                                                    })}
                                                </nav>
                                            );
                                        }
                                    }
                                }
                            })}
                        </li>
                    </ul>
                )}
            </div>
        </label>
    );
}

export function MultiSelect({
    title,
    onChange,
    style,
    validate,
    inputStyle,
    values,
    value,
    placeholder,
    external,
    click,
}) {
    const { t } = useTranslation();
    let isScrolling;
    const [open, setopen] = useState(false);
    const [va, setv] = useState([]);
    const [vtext, setvtext] = useState("");
    const [search, setsearch] = useState("");
    const [list, setlist] = useState([]);

    if (!placeholder) {
        placeholder = "--";
    }

    useEffect(() => {
        const closeFunc = (e) => {
            const selClose = e?.target.closest(".selectBox");
            if (!selClose) {
                setopen(false);
            }
        };

        window.addEventListener("click", closeFunc);

        return () => {
            window.removeEventListener("click", closeFunc);
        };
    }, []);

    function checked(d) {
        if (click) {
            setv([d]);
            setopen(false);
        } else {
            let ck = va?.filter((r) => r == d);
            if (ck?.length) {
                setv((p) => [...p?.filter((r) => r != d)]);
            } else {
                setv((p) => [...p, d]);
            }
        }
    }

    // console.log(value);

    useEffect(() => {
        if (external) {
            Fetch(
                external,
                (d) => {
                    let arr = [];
                    d?.map((v) => {
                        arr.push({ name: v?.name, val: v?._id });
                    });
                    setlist(arr);

                    if (value?.length) {
                        let checked = [];
                        let checkedID = [];
                        value?.map((v) => {
                            checked.push(v?.name);
                            checkedID.push(v?._id);
                        });
                        setvtext(checked.join(", "));
                        setv(checkedID);
                    }
                },
                { search: search },
            );
        }
    }, [search]);

    useEffect(() => {
        setlist(values);
    }, [values]);

    useEffect(() => {
        if (value && !external) {
            setv(value);
        }
    }, []);

    useEffect(() => {
        if (click) {
            let filtList = list?.filter((p) => p?.val == va);
            onChange(filtList[0]);
        } else {
            onChange(va);
        }

        let res = [];
        va?.map((r, k) => {
            let rV = list?.filter((c) => c?.val == r);
            if (rV?.length) {
                res.push(rV[0]?.name);
            }
        });

        setvtext(res.join(", "));
    }, [va]);

    return (
        <label style={style} className={"formInputBox focused"}>
            {title && (
                <span>
                    {title ? `${title}:` : false} {validate && <b>*</b>}
                </span>
            )}

            <div className="selectBox">
                <div
                    style={inputStyle}
                    tabindex="0"
                    onKeyDown={() => setopen((p) => !p)}
                    onClick={() => setopen((p) => !p)}
                    className="selectName"
                >
                    {vtext || placeholder} <IoMdArrowDropdown />
                </div>
                <nav className={`dropDownBox ${open ? "open" : "closed"}`}>
                    <input
                        type="search"
                        autocomplete="false"
                        onChange={(d) => setsearch(d?.target?.value)}
                        name="q"
                        placeholder={`${t("search")}..`}
                    />
                    <div className="multiSelectBox">
                        {list?.map((v, k) => {
                            let visible = true;
                            if (search && !external) {
                                // if (v?.name?.indexOf(search) == -1) {
                                if (
                                    v?.name
                                        ?.toLowerCase()
                                        ?.indexOf(search?.toLowerCase()) == -1
                                ) {
                                    visible = false;
                                }
                            }

                            if (visible) {
                                let checkedD = va?.filter(
                                    (p) => p == v?.val,
                                )?.length;

                                let Arrow = <></>;
                                if (v?.main == "sub") {
                                    Arrow = (
                                        <BsArrowReturnLeft
                                            style={{
                                                color: "#555",
                                                fontSize: 14,
                                                marginRight: 0,
                                            }}
                                        />
                                    );
                                }

                                if (v?.val) {
                                    return (
                                        <label
                                            tabindex="0"
                                            style={{
                                                fontWeight:
                                                    v?.main == "main" && 700,
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.code == "Space") {
                                                    e.preventDefault();
                                                    checked(v?.val);
                                                }
                                            }}
                                            onClick={() => {
                                                checked(v?.val);
                                            }}
                                            key={k}
                                        >
                                            {Arrow}
                                            {checkedD ? (
                                                <IoIosCheckbox />
                                            ) : (
                                                <MdOutlineCheckBoxOutlineBlank />
                                            )}{" "}
                                            {v?.name}
                                        </label>
                                    );
                                } else {
                                    return (
                                        <label tabindex="0" key={k}>
                                            {v?.name}
                                        </label>
                                    );
                                }
                            }
                        })}
                    </div>
                </nav>
            </div>
        </label>
    );
}

export function uploadFiles({
    title,
    validate,
    value,
    onChange,
    multiple,
    style,
    type,
}) {}

export function ImageUpload({
    title,
    validate,
    value,
    onChange,
    multiple,
    style,
    type,
}) {
    if (!multiple) {
        multiple = false;
    }

    let defaultImg = `${Config?.uploadFolder}nopic.jpg`;

    const [images, setimages] = useState([value ? value : defaultImg]);
    const [loader, setloader] = useState(false);

    const { successData } = useContext(AppContext);
    const [open, setopen] = successData;

    const [multiImg, setmultiImg] = useState([]);

    if (!type) {
        type = "img";
    }

    async function upload(event) {
        event.preventDefault();

        if (event.target.files && event.target.files[0]) {
            const formData = new FormData();

            // Update the formData object
            formData.append("files", event.target.files[0]);

            const requestOptions = {
                method: "POST",
                credentials: "include",
                body: formData,
            };

            try {
                const res = await fetch(
                    Config.domain + "upload",
                    requestOptions,
                );
                if (res.status != 200) {
                    setopen({
                        title: "Error",
                        short: "Server Error",
                        error: true,
                    });
                } else {
                    const data = await res?.json();
                    if (data?.error) {
                        setopen({
                            title: "Error",
                            short: data?.error,
                            error: true,
                        });
                    } else {
                        setimages(data);
                        if (data?.length > 1) {
                            onChange(data);
                        } else {
                            onChange(data[0]);
                        }
                    }
                }
            } catch (e) {
                console.log(e?.message);
            }
        }
    }

    return (
        <>
            {loader && <Loader />}

            <label style={style} className={"formInputBox focused"}>
                <span>
                    {title ? `${title}:` : false} {validate && <b>*</b>}
                </span>

                <div
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        gap: 10,
                        flexWrap: "wrap",
                    }}
                >
                    {images?.map((v, k) => {
                        return (
                            <img
                                className="uploadForm Img"
                                src={`${Config?.imgUrl}${v}`}
                                key={k}
                            />
                        );
                    })}
                </div>

                <input
                    className="uploadField"
                    multiple={multiple}
                    onChange={upload}
                    type="File"
                />
            </label>
        </>
    );
}

export function SelectBox({
    title,
    validate,
    value,
    values,
    onChange,
    disabled,
    inputStyle,
    style,
    placeholder,
    top,
}) {
    const [open, setopen] = useState("closed");
    const [search, setsearch] = useState("");
    const [loader, setloader] = useState(true);

    function submit(v) {
        setopen("closed");
        onChange(v);
    }

    if (placeholder) {
        if (values) {
            values = [{ name: placeholder, val: false }, ...values];
        }
    }

    useEffect(() => {
        if (!value?.name) {
            if (values) {
                let valr = values[0];

                onChange(valr);
            }
        }

        setTimeout(() => {
            setloader(false);
        }, 100);

        const closeFunc = (e) => {
            const selClose = e?.target.closest(".selectBox");
            if (!selClose) {
                setopen("closed");
            }
        };

        window.addEventListener("click", closeFunc);
        return () => {
            window.removeEventListener("click", closeFunc);
        };
    }, []);

    if (loader) {
        return false;
    }

    return (
        <label style={style} className={"formInputBox focused"}>
            {title && (
                <span>
                    {title ? `${title}:` : false} {validate && <b>*</b>}
                </span>
            )}

            <div className="selectBox">
                <div
                    style={inputStyle}
                    onClick={() =>
                        disabled
                            ? false
                            : setopen((p) => (p ? "open" : "closed"))
                    }
                    className="selectName"
                >
                    {value?.name} <IoMdArrowDropdown />
                </div>

                <nav className={`dropDownBox ${top && "top"} ${open}`}>
                    <input
                        type="search"
                        onChange={(d) => setsearch(d?.target?.value)}
                        name="q"
                        placeholder={`بحث..`}
                    />
                    <div>
                        {values?.map((v, k) => {
                            let visible = true;
                            if (search) {
                                if (
                                    v?.name
                                        ?.toLowerCase()
                                        ?.indexOf(search?.toLowerCase()) == -1
                                ) {
                                    visible = false;
                                }
                            }

                            if (visible) {
                                return (
                                    <a onClick={(e) => submit(v)} key={k}>
                                        {v?.name}
                                    </a>
                                );
                            }
                        })}
                    </div>
                </nav>
            </div>
        </label>
    );
}

export function ClassesDropdown({ onChange, value, type, validate, click }) {
    const { t } = useTranslation();
    const [classes, setclasses] = useState([]);
    const [values, setvalues] = useState({ classes: value });

    const { userData } = useContext(AppContext);
    const [userinfo, setuserinfo] = userData;

    useEffect(() => {
        let Cls = [];

        if (type == "classes") {
            Object.entries(global.Classes)?.map((v) => {
                Cls.push({ name: `${t("class")} ${v[1]}`, val: `${v[0]}` });
            });
        } else if (type == "own") {
            userinfo?.classes?.map((v) => {
                let cls = v?.split("-")[0];
                let grd = v?.split("-")[1];

                Cls.push({
                    name: `${t("class")} ${global.Classes[cls]} (${global.Grades[grd]})`,
                    val: `${cls}-${grd}`,
                });
            });
        } else {
            Object.entries(global.Classes)?.map((v) => {
                Object.entries(global.Grades)?.map((v2) => {
                    Cls.push({
                        name: `${t("class")} ${v[1]} (${v2[1]})`,
                        val: `${v[0]}-${v2[0]}`,
                    });
                });
            });
        }

        setclasses(Cls);
    }, []);

    useEffect(() => {
        if (values?.classes?.name) {
            onChange([values?.classes?.val]);
        } else {
            onChange(values?.classes);
        }
    }, [values]);

    if (!classes?.length) {
        return false;
    }

    return (
        <MultiSelect
            click={click}
            title={t("classes")}
            validate={validate}
            values={classes}
            onChange={(v) =>
                setvalues((p) => ({
                    ...p,
                    classes: v,
                }))
            }
            value={values?.classes}
        />
    );
}

export function RichText({
    value,
    validate,
    onChange,
    toolbar,
    bodyStyle,
    height,
}) {
    const { t, i18n } = useTranslation();
    const editorRef = useRef(null);
    let location = useLocation();
    let navigate = useNavigate();

    const [pop, setpop] = useState("");
    const [math, setmath] = useState(false);

    const mathTypes = [
        {
            name: t("math_aljabra_1"),
        },
        // {
        //     name: t("math_aljabra_2"),
        // }
    ];

    function insertInto(data) {
        if (data?.type == "textField") {
            tinymce?.activeEditor?.execCommand(
                "mceInsertContent",
                false,
                `<inp id='d${Date.now()}'>${data?.value}</inp>`,
            );
        }
        if (data?.type == "img") {
            tinymce?.activeEditor?.execCommand(
                "mceInsertContent",
                false,
                `<img src='${Config.imgUrl}${data?.value}' />`,
            );
        }
        if (data?.type == "mp3") {
            tinymce?.activeEditor?.execCommand(
                "mceInsertContent",
                false,
                `
                <audio controls>
                    <source src="${Config.imgUrl}${data?.value}" type="audio/mpeg">
                </audio>
            `,
            );
        }
        if (data?.type == "video") {
            if (data?.tab === 1) {
                tinymce?.activeEditor?.execCommand(
                    "mceInsertContent",
                    false,
                    `
                    <div class='teacherVideoBox' style='width:590px; height:332px;'>
                        ${data?.controll?.val === 1 ? "" : `<button class='playVideo'><span>${t("start")}</span></button>`}
                        <video style='width:100%; height:100%;' ${data?.controll?.val === 1 ? "controls" : ""}>
                            <source src="${Config.imgUrl}${data?.video}" type="video/mp4">
                        </video>
                    </div>
                `,
                );
            } else if (data?.tab === 2) {
                tinymce?.activeEditor?.execCommand(
                    "mceInsertContent",
                    false,
                    `
                    <div class='teacherYoutubeBox' style='width:590px; height:332px;'>
                    <iframe 
                        width="100%" 
                        height="100%" 
                        style='width:100%; height:100%;'
                        src="https://www.youtube.com/embed/${data?.youtube}?disablekb=${data?.controll?.val === 1 ? "0" : "1"}&controls=${data?.controll?.val === 1 ? "1" : "0"}" 
                        frameborder="0" 
                        allow="autoplay; encrypted-media" 
                        allowfullscreen>
                    </iframe>
                    `,
                );
            }
        }

        if (data?.type == "math") {
            let x = data?.value?.filter((r) => r?.key == "x");
            let y = data?.value?.filter((r) => r?.key == "y");
            let z = data?.value?.filter((r) => r?.key == "z");

            const html = `
                <div class='fractionBox'>
                    <div class='rightFrac'>
                        <label>${x[0]?.type == "number" ? `<b>${x[0]?.value}</b>` : `<spanInput data-type='x'>${x[0]?.value}</spanInput>`}</label>
                        <hr />
                        <label>${y[0]?.type == "number" ? `<b>${y[0]?.value}</b>` : `<spanInput data-type='y'>${y[0]?.value}</spanInput>`}</label>
                    </div>

                    ${
                        z?.length
                            ? `
                        <div class='leftFrac'>
                            <b>=</b>
                            <label>${z[0]?.type == "number" ? `<b>${z[0]?.value}</b>` : `<spanInput data-type='z'>${z[0]?.value}</spanInput>`}</label>
                        </div>
                    `
                            : ""
                    }
                    
                </div>
            `;
            tinymce?.activeEditor?.execCommand("mceInsertContent", false, html);
        }
    }

    if (!toolbar) {
        toolbar =
            "undo redo | " +
            "bold italic forecolor fontfamily fontsize | alignleft aligncenter " +
            "alignright alignjustify | bullist numlist outdent indent | link table | media testBTN | removeformat preview code ltr rtl ";
    }
    return (
        <>
            {pop == "textField" && (
                <TextInput
                    setOpen={setpop}
                    Open={pop}
                    onChange={(d) => insertInto(d)}
                />
            )}
            {pop == "img" && (
                <ImgInput
                    setOpen={setpop}
                    Open={pop}
                    onChange={(d) => insertInto(d)}
                />
            )}
            {pop == "mp3" && (
                <Mp3
                    setOpen={setpop}
                    Open={pop}
                    onChange={(d) => insertInto(d)}
                />
            )}
            {pop == "math" && (
                <MathData
                    setOpen={setpop}
                    math={math}
                    Open={pop}
                    onChange={(d) => insertInto(d)}
                />
            )}
            {pop == "video" && (
                <VideoInput
                    setOpen={setpop}
                    math={math}
                    Open={pop}
                    onChange={(d) => insertInto(d)}
                />
            )}

            <Editor
                apiKey="u3ru69nq06tfrhaljxpzrdd42fal24zruoz5r0se0yirdxh6"
                onInit={(_evt, editor) => (editorRef.current = editor)}
                tinymceScriptSrc={
                    process.env.PUBLIC_URL + "/tinymce/tinymce.min.js"
                }
                value={value}
                onEditorChange={(d) => onChange(d)}
                init={{
                    license_key: "gpl",
                    setup: function (editor) {
                        editor.ui.registry.addButton("imgs", {
                            icon: "image",
                            tooltip: t("task_type_4"),
                            onAction: (e) => {
                                setpop("img");
                            },
                        });

                        editor.ui.registry.addButton("textField", {
                            icon: "duplicate-row",
                            tooltip: t("task_type_5"),
                            onAction: (e) => {
                                setpop("textField");
                            },
                        });

                        editor.ui.registry.addButton("mp3", {
                            icon: "arrow-right",
                            tooltip: t("task_type_6"),
                            onAction: (e) => {
                                setpop("mp3");
                            },
                        });

                        editor.ui.registry.addButton("video", {
                            icon: "embed",
                            tooltip: t("task_type_8"),
                            onAction: (e) => {
                                setpop("video");
                            },
                        });

                        var items = [];
                        mathTypes?.map((v, k) => {
                            items.push({
                                type: "menuitem",
                                text: v?.name,
                                onAction: function () {
                                    setpop("math");
                                    setmath(k);
                                },
                            });
                        });

                        editor.ui.registry.addMenuButton("math", {
                            text: t("task_type_7"),
                            fetch: function (callback) {
                                callback(items);
                            },
                        });

                        // editor.ui.registry.addButton("math", {
                        //     type: 'menubutton',
                        //     icon: 'superscript',
                        //     tooltip: t("task_type_7"),
                        //     onAction: (e) => {
                        //         setpop("math");
                        //     },
                        //     menu: [
                        //         {icon: 'alignleft', onclick: console.log("aaa")},
                        //         {icon: 'alignleft', onclick: console.log("aaa")},
                        //     ]
                        // });
                    },

                    height: height || 400,
                    menubar: false,
                    statusbar: false,
                    language: t("tiny_dir"),
                    valid_elements: "*[*]",
                    remove_script_host: false,
                    convert_urls: false,
                    relative_urls: false,
                    // extended_valid_elements: 'inp[*]',
                    // valid_children:"+body[style]",
                    // directionality :"rtl",
                    plugins: [
                        "advlist",
                        "autolink",
                        "lists",
                        "link",
                        "image",
                        "charmap",
                        "preview",
                        "anchor",
                        "searchreplace",
                        "visualblocks",
                        "code",
                        "fullscreen",
                        "insertdatetime",
                        "media",
                        "table",
                        "code",
                        "help",
                        "wordcount",
                        "directionality",
                    ],
                    inline_boundaries: false,
                    toolbar1: toolbar,
                    // toolbar2: 'media',
                    content_style: t("tiny_style"),
                    content_css: "/tiny.css",
                }}
            />
        </>
    );
}

export function UploadForm({
    name,
    short,
    title,
    multi,
    value,
    onChange,
    small,
    accept,
    boxClass,
}) {
    const { t } = useTranslation();
    let array = Array.isArray(value);
    if (array) {
        array = value;
    } else {
        array = [value];
    }

    const [values, setvalues] = useState(array);

    if (!multi) {
        multi = false;
    }

    function deleteEffect(file) {
        let cof = window.confirm(t("error", { returnObjects: true })[2]);

        if (!cof) {
            return false;
        }
        setvalues((p) => [...p?.filter((r) => r != file)]);
    }

    function addEffect(data) {
        if (multi) {
            let effectLast = values?.length ? values : [];
            let arr = [...effectLast, ...data];
            setvalues(arr);
        } else {
            setvalues(data);
        }
    }

    function onpressUp() {
        const fileInput = document.getElementById("fileInput");
        fileInput.click();
    }

    useEffect(() => {
        onChange(values);
    }, [values]);

    return (
        <div
            class={`ThemeformInputBox ${small ? "smallImgInput" : ""} ${boxClass}`}
            style={{ marginTop: 40 }}
        >
            {name && (
                <span className="name" style={{ margin: 0 }}>
                    {name}:<b>*</b>
                </span>
            )}
            {short && (
                <span
                    className="short"
                    style={{ marginTop: 1, fontWeight: 300 }}
                >
                    {short}
                </span>
            )}

            <div className={`uploadVideoAndImgBox `} style={{ marginTop: 0 }}>
                {values?.map((v, k) => {
                    let ext = v?.split(".").pop();

                    return (
                        <div key={k} className="uploadVideoAndImgThumb">
                            <MdDelete
                                onClick={() => deleteEffect(v)}
                                className="deleteImgVid"
                            />
                            {ext == "mp4" ? (
                                <video controls className="uploadVideoAndImg">
                                    <source
                                        src={`${Config.imgUrl}${v}`}
                                        type="video/mp4"
                                    />
                                </video>
                            ) : (
                                <Img src={v} size="img/150x150" />
                            )}
                        </div>
                    );
                })}

                {!values?.length || multi ? (
                    <label
                        onKeyDown={onpressUp}
                        tabindex="0"
                        id="fileLabel"
                        className="uploadVideoAndImg"
                    >
                        <IoCloudUploadOutline />
                        <strong>{title || t("choose_files")}</strong>
                        <HiddenUpload
                            onChange={(d) => addEffect(d)}
                            multiple={multi}
                            accept={accept}
                        />
                    </label>
                ) : (
                    false
                )}
            </div>
        </div>
    );
}

export function HiddenUpload({
    title,
    validate,
    value,
    onChange,
    disabled,
    inputStyle,
    style,
    type,
    multiple,
    accept,
}) {
    if (!accept) {
        accept = "*";
    }

    const { successData } = useContext(AppContext);
    const [open, setopen] = successData;
    const [file, setfile] = useState([value || ""]);
    const [loader, setloader] = useState(false);
    const [biewV, setbiewV] = useState(false);

    async function uploadAllFiltes(files) {
        const formData = new FormData();

        formData.append("files", files);

        const requestOptions = {
            method: "POST",
            credentials: "include",
            body: formData,
        };

        try {
            setloader(true);
            const res = await fetch(
                Config.domain + "upload_new",
                requestOptions,
            );

            setloader(false);
            if (res.status != 200) {
                setopen({
                    title: "Error",
                    short: "Server Error",
                    error: true,
                });
            } else {
                const data = await res?.json();
                if (data?.error) {
                    setopen({
                        title: "Error",
                        short: data?.error,
                        error: true,
                    });
                } else {
                    if (data?.length > 1) {
                        return data;
                    } else {
                        return data[0];
                    }
                }
            }
        } catch (e) {
            console.log(e?.message);
        }
    }

    async function upload(event) {
        event.preventDefault();

        if (event.target.files && event.target.files[0]) {
            let arr = [];
            await Promise.all(
                [...event.target.files]?.map(async (v) => {
                    let r = await uploadAllFiltes(v);
                    arr.push(r);
                }),
            );

            onChange(arr);
        }

        event.target.value = "";
    }

    return (
        <>
            {loader && <Loader styles={{ position: "absolute" }} />}
            <input
                autoComplete="new-password"
                id="fileInput"
                type={"File"}
                style={inputStyle}
                disabled={disabled}
                accept={accept}
                multiple={multiple}
                name={"file"}
                onChange={upload}
            />
        </>
    );
}

export function ListOptions({ data, type, onChange, imgs, accept }) {
    const { t } = useTranslation();

    const [values, setvalues] = useState(data);

    // console.log(data);

    function saved(d, k) {
        setvalues((p) => {
            let arr = [];
            p?.map((vv, kk) => {
                if (k == kk) {
                    arr.push(d);
                } else {
                    if (type == "radio") {
                        if (d?.checked) {
                            vv.checked = false;
                        }
                    }

                    arr.push(vv);
                }
            });
            return arr;
        });
    }

    useEffect(() => {
        if (!data?.length) {
            let arr = [];
            let val = {
                img: "",
                answer: "",
                checked: false,
            };

            for (let i = 0; i < 4; i++) {
                arr.push(val);
            }

            setvalues(arr);
        }
    }, []);

    useEffect(() => {
        if (typeof onChange !== "undefined") {
            onChange(values?.filter((p) => p?.answer));
        }
    }, [values]);

    return (
        <>
            {values?.map((v, k) => {
                return (
                    <Options
                        key={k}
                        value={v}
                        onChange={(d) => saved(d, k)}
                        type={type}
                        imgs={imgs}
                        accept={accept}
                    />
                );
            })}
        </>
    );
}

export function Options({ multi, accept, type, onChange, value, imgs }) {
    const { t } = useTranslation();
    const [checked, setchecked] = useState(value?.answer ? value : {});

    if (!multi) {
        multi = false;
    }
    if (!accept) {
        accept = "*";
    }

    useEffect(() => {
        if (typeof onChange !== "undefined") {
            onChange(checked);
        }
    }, [checked]);

    let ext = !checked?.img ? false : checked?.img?.split(".")?.pop();

    return (
        <div className="radioOptionsBox">
            <div className="radioOptions">
                {!imgs && (
                    <label
                        title={t("tasks_question_upload_allow")}
                        className="radioOptionsImg"
                        style={{ padding: checked?.img && 5 }}
                    >
                        {checked?.img ? (
                            <>
                                {ext == "mp3" ? (
                                    <div className="audioBox">
                                        <GiSoundWaves />
                                    </div>
                                ) : (
                                    <Img
                                        src={checked?.img}
                                        size="img/150x150"
                                    />
                                )}
                            </>
                        ) : (
                            <MdAttachFile />
                        )}

                        <HiddenUpload
                            onChange={(d) =>
                                setchecked((p) => ({
                                    ...p,
                                    img: d[0] || "",
                                }))
                            }
                            multiple={multi}
                            accept={accept}
                        />
                    </label>
                )}

                <label className="radioOptionsText">
                    <input
                        type="text"
                        onChange={(d) =>
                            setchecked((p) => ({
                                ...p,
                                answer: d?.target?.value,
                            }))
                        }
                        value={checked?.answer}
                        placeholder={`${t("task_answer")} `}
                    />
                </label>
            </div>

            <label className="radioBtnBox">
                <span>{t("task_right_answer")}</span>
                {type == "checkbox" ? (
                    <>
                        {checked?.checked ? (
                            <MdCheckBox
                                onClick={() =>
                                    setchecked((p) => ({
                                        ...p,
                                        checked: !p?.checked,
                                    }))
                                }
                                className="radioBtn"
                            />
                        ) : (
                            <MdCheckBoxOutlineBlank
                                onClick={() =>
                                    setchecked((p) => ({
                                        ...p,
                                        checked: !p?.checked,
                                    }))
                                }
                                className="radioBtn"
                            />
                        )}
                    </>
                ) : (
                    <>
                        {checked?.checked ? (
                            <IoMdRadioButtonOn
                                onClick={() =>
                                    setchecked((p) => ({
                                        ...p,
                                        checked: !p?.checked,
                                    }))
                                }
                                className="radioBtn"
                            />
                        ) : (
                            <IoMdRadioButtonOff
                                onClick={() =>
                                    setchecked((p) => ({
                                        ...p,
                                        checked: !p?.checked,
                                    }))
                                }
                                className="radioBtn"
                            />
                        )}
                    </>
                )}
            </label>
        </div>
    );
}
